import { render } from "./Profiles.vue?vue&type=template&id=679c3c46"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"
script.render = render

export default script